import React from "react";
import { ManageGracePeriodSwitch } from "../modules/ManageGracePeriodSwitch/ManageGracePeriodSwitch";
import { ManageVariationsSwitch } from "../modules/ManageVariationsSwitch/ManageVariationsSwitch";
export const MANAGE_AVAILABILITY_TITLE = "Subscriptions";

export const MANAGE_SUBSCRIPTIONS_KEYS = {
  GRACE_PERIOD: "subscription_grace_period",
  VARIATIONS: "is_offering_variants_enabled",
};

export const SUBSCRIPTIONS_SECTION_SUBSECTION_KEYS = {
  BOOKINGSETUP: "booking-setup",
  SUBSCRIPTIONS: "subscriptions",
};

// Define unique IDs for subsections
export const MANAGE_SUBSCRIPTIONS_IDS = {
  GRACE_PERIOD: "subscription_grace_period",
  VARIATIONS: "offering_variants",
};

export const GRACE_PEROID_VALIDATION_CONSTANTS = {
  MAX_LIMIT: 30,
  DEFAULT: 7,
};

export const MANAGE_AVAILABILITY_CONFIG = [
  {
    id: MANAGE_SUBSCRIPTIONS_IDS.GRACE_PERIOD,
    title: "Grace Period for Subscriptions",
    description:
      "Let customers keep offering access after renewal date. Set grace period duration.",
    subSectionConfig: [
      {
        key: MANAGE_SUBSCRIPTIONS_KEYS.GRACE_PERIOD,
        title: "Enable grace period",
        customRightJSX: (
          <ManageGracePeriodSwitch
            subSectionKey={MANAGE_SUBSCRIPTIONS_KEYS.GRACE_PERIOD}
          />
        ),
        description:
          "Toggle on to let customers keep access even if they haven’t renewed their subscription yet. You can choose how long the grace period lasts.",
      },
    ],
  },
  {
    id: MANAGE_SUBSCRIPTIONS_IDS.VARIATIONS,
    title: "Subscription Variations",
    description:
      "Create and manage custom pricing and subscription plans to offer flexible booking options.",
    subSectionConfig: [
      {
        key: MANAGE_SUBSCRIPTIONS_KEYS.VARIATIONS,
        title: "Enable Variations",
        customRightJSX: <ManageVariationsSwitch />,
        description:
          "Enabling this will make all variations visible on the offering’s event page when the customer is making a booking. All variation will be displayed in a dropdown and customers can choose a variation as per their interest and requirements.",
      },
    ],
  },
];
